export default __webpack_public_path__ + "static/media/friends-and-family-referral-card.cb270ff5.svg";